import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Configure axios to send cookies with requests
axios.defaults.withCredentials = true;

// Add a new sub-user
export const addSubUser = async (userData) => {
  try {
    const response = await axios.post(`${API_URL}/sub-users`, userData);
    return response.data;
  } catch (error) {
    throw error.response?.data || { success: false, message: 'Error adding user' };
  }
};

// Get all sub-users
export const getAllSubUsers = async (params) => {
  try {
    const response = await axios.get(`${API_URL}/sub-users`, { params });
    return response.data;
  } catch (error) {
    throw error.response?.data || { success: false, message: 'Error fetching users' };
  }
};

// Update sub-user status
export const updateSubUserStatus = async (userId, user_status) => {
  try {
    const response = await axios.put(`${API_URL}/sub-users/${userId}/status`, { user_status });
    return response.data;
  } catch (error) {
    throw error.response?.data || { success: false, message: 'Error updating user status' };
  }
};

// Update sub-user
export const updateSubUser = async (userId, userData) => {
  try {
    const response = await axios.put(`${API_URL}/sub-users/${userId}`, userData);
    return response.data;
  } catch (error) {
    throw error.response?.data || { success: false, message: 'Error updating user' };
  }
};

export default {
  addSubUser,
  getAllSubUsers,
  updateSubUserStatus,
  updateSubUser
};
